import PullToRefresh from "react-simple-pull-to-refresh"

import { LoadingSpinner, SwipeToClose } from "@/components/shared"
import { GoBack } from "@/components/shared/layout"
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet"
import { AffiliateProductDetails } from "@/features/jobs/affiliates/components/affiliate-product"
import { ApplyCampaignForm } from "@/features/jobs/explore/components/campaign/actions"
import { AffiliateCampaignDetail } from "@/features/jobs/explore/components/campaign/campaign-detail-section"
import ScreenLayout from "@/layouts/screen"
import { useQueryCampaignById } from "@/modules/helpers/hooks"
import { useQuerySampleStatus } from "@/modules/helpers/hooks/react-query/use-query-sample-status"
import { useShowCampaign } from "@/modules/helpers/hooks/shared"
import { cn } from "@/modules/helpers/hooks/shared/utils"
import { sendHaptic } from "@/modules/helpers/utils"

const CampaignDetailsSheet = () => {
  const { id, setId } = useShowCampaign()
  const { data, refetch, isLoading, isFetching } = useQueryCampaignById(id)
  const { data: isSampleRegistered } = useQuerySampleStatus(data?.kolSubmissionId)

  // Detect stale data (loaded data belongs to previous campaign)
  const isStale = !!id && !!data?.id && data.id !== id
  const showLoading = isLoading || isStale

  const handleRefresh = async () => {
    await refetch()
  }

  const handleClose = () => {
    sendHaptic()
    setId("")
  }

  return (
    <Sheet open={!!id} modal>
      <SheetContent className="w-full !bg-transparent border-none" side="right" hiddenClose>
        <SheetTitle className="sr-only">Chi tiết chiến dịch</SheetTitle>
        <SwipeToClose
          isOpen={!!id}
          onClose={handleClose}
          className="h-full relative z-10 "
          threshold={120}
          velocityThreshold={0.8}
          minStartX={120}
        >
          {({ onClose }) => (
            <ScreenLayout transition="none">
              <div
                className={cn(
                  "flex flex-col h-screen absolute top-0 z-50 w-full max-h-[100dvh] items-center justify-center bg-white text-black transition-all duration-300",
                  {
                    "opacity-0 z-0 ": !showLoading
                  }
                )}
              >
                <LoadingSpinner className="w-32 h-32" />
              </div>
              <div
                className={cn("flex flex-col relative z-10 h-full transition-all duration-300", {
                  "opacity-0": showLoading || !data?.id
                })}
              >
                <div className="bg-white sticky top-0 z-20">
                  <GoBack onClick={onClose} />
                </div>
                {/* Content */}
                <PullToRefresh
                  onRefresh={handleRefresh}
                  pullingContent=""
                  refreshingContent={<LoadingSpinner className="w-20 h-20" />}
                  maxPullDownDistance={80}
                >
                  <div className="flex-1 flex flex-col">
                    <AffiliateCampaignDetail data={data} layoutBanner="upper" />
                    <div className="px-4 pb-8 bg-background pt-4 rounded-t-3xl">
                      <AffiliateProductDetails
                        id={data?.products?.id}
                        layoutBanner="upper"
                        isShowAction={false}
                        data={data?.products}
                        preload={true}
                      />
                    </div>
                  </div>
                </PullToRefresh>
                <div className="sticky bottom-0 z-20 bg-white">
                  <ApplyCampaignForm
                    key={data?.id}
                    data={data}
                    refetch={refetch}
                    initialSampleRegistered={isSampleRegistered}
                    isFetching={isFetching}
                  />
                </div>
              </div>
            </ScreenLayout>
          )}
        </SwipeToClose>
      </SheetContent>
    </Sheet>
  )
}

export { CampaignDetailsSheet }
